import { EditOutlined } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { PageSection } from 'components/PageSection/PageSection';
import { Panel } from 'components/Panel/Panel';
import { ShrinkToIconButton } from 'components/ShrinkToIconButton/ShrinkToIconButton';
import { StandardDetailsViewBody } from 'pages/ProjectDashboard/ProjectDashboard';
import { useTranslation } from 'react-i18next';
import { Standard } from '../../types/domainTypes';
import { ReactElement } from 'react';

interface CalculationStandardsViewProps {
  standard?: Standard;
  setIsEditStandardDialogOpen: (isDialogOpen: boolean) => void;
}

export function CalculationStandardsView({ standard, setIsEditStandardDialogOpen }: CalculationStandardsViewProps): ReactElement {
  const { t } = useTranslation();

  const panelButton = (
    <ShrinkToIconButton
      buttonText={t('calculation-page.edit-calculation-standard-button')}
      icon={<EditOutlined />}
      onClick={() => setIsEditStandardDialogOpen(true)}
    />
  );

  if (standard) {
    return (
      <Panel
        panelTitle={t('calculation-page.label-calculation-standard')}
        panelSummary={t('common.summary-format', {
          createdBy: standard.createdByName ? standard.createdByName : standard.createdBy,
          modifiedOn: standard.modifiedOn,
          modifiedBy: standard.modifiedByName ? standard.modifiedByName : standard.modifiedBy,
        })}
        panelButton={panelButton}
        data-testid="standards-panel"
      >
        <StandardDetailsViewBody standard={standard} />
      </Panel>
    );
  }

  return (
    <PageSection
      onClick={() => setIsEditStandardDialogOpen(true)}
      variant={'outlined'}
      sx={{ border: 'none', boxShadow: 'none', height: '300px', display: 'flex', justifyContent: 'center' }}
    >
      <Stack justifyContent="center" alignItems="center" spacing={2}>
        <Typography variant="h6" fontFamily="KingspanBrownTT-Bold">
          {t('calculation-page.label-calculation-standard')}
        </Typography>
      </Stack>
    </PageSection>
  );
}
